import {Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from '@mui/material';
import dayjs from 'dayjs';

// Example DTO type
type BusinessSecured = {
    bookingReference: string;
    organizationName: string;
    eventType: string;
    companyName: string;
    eventDate: string; // ISO string or Date
    revenueSecured: string;
};

export default function BusinessSecuredDialog({data}: { data: BusinessSecured[] }) {
    return (
        <TableContainer component={Paper}>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell>Booking Ref</TableCell>
                        <TableCell>Organization</TableCell>
                        <TableCell>Event Type</TableCell>
                        <TableCell>Company</TableCell>
                        <TableCell>Event Date</TableCell>
                        <TableCell align="right">Revenue Secured</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.map((row) => (
                        <TableRow key={row.bookingReference}>
                            <TableCell>{row.bookingReference}</TableCell>
                            <TableCell>{row.organizationName}</TableCell>
                            <TableCell>{row.eventType}</TableCell>
                            <TableCell>{row.companyName}</TableCell>
                            <TableCell>{dayjs(row.eventDate).format('DD MMM YYYY')}</TableCell>
                            <TableCell align="right">{row.revenueSecured}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
